import { useMutation } from 'react-query';
import { REQUEST_ACTIONS } from '~/Constants/Actions.constants';
import { USER_SERVICE_URLS } from '~/Constants/Urls.constants';
import { requestReactQuery } from '~/Helpers/ReactQuery.helper';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { IDeleteRole } from '~/Models/DTO/IDeleteRole.model';

interface RoleDeleteRequest {
  providerId: string;
  clientId: string;
}

export const useRequestDeleteIntegration = () =>
  useMutation<IDeleteRole, IErrorResponse, RoleDeleteRequest>(
    REQUEST_ACTIONS.INTEGRATION_DELETE,
    async (roleDelete) => {
      const response = await requestReactQuery<IDeleteRole>({
        url: USER_SERVICE_URLS.DELETE_INTEGRATION,
        config: { method: 'DELETE' },
        data: roleDelete,
      });

      return response;
    },
  );
